<template>
  <div class="flex flex-row items-center gap-4">
    <gv-dropdown>
      <template #default="{ open, toggleOpen }">
        <div id="change-language-button-label" aria-hidden="true" class="sr-only">{{ t('FIn_IOdHsOTUHpXuXn6wN') }}</div>
        <button
          aria-labelledby="change-language-button-label"
          aria-controls="change-language-menu"
          class="flex items-center gap-1 underline"
          :aria-expanded="open"
          @click.stop="toggleOpen()"
        >
          <gv-icon name="language" size="xs" class="fill-white" />
          {{ currentLocaleName }}
          <gv-icon-sharp :name="open ? 'expand_less' : 'expand_more'" class="fill-white" size="sm" />
        </button>
      </template>
      <template #menu>
        <gv-menu id="change-language-menu" class="max-h-32 w-[256px] overflow-y-auto" size="custom">
          <div class="flex flex-col p-4">
            <ui-language-items />
          </div>
        </gv-menu>
      </template>
    </gv-dropdown>
    <google-translate-attribution v-if="isPageTranslated" />
  </div>
</template>

<script setup lang="ts">
import { currentLocaleName, i18n } from '@/locales';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const isPageTranslated = computed(() => {
  return i18n.global.locale.value !== 'en-CA';
});
</script>
